import { Accordion, Button, Form, Grid, Icon } from 'semantic-ui-react';
import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  InputField,
  SelectField,
  DatePickerField,
} from 'Common/SemanticWrapper';
import {
  SiteStatusEnum,
  NewEditPhysicalEnum,
} from 'Common/Constants/Enumeration/PhysicalEnum';
import { getDates } from 'Common/FormHelper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { CreateEditPhysicalEnum, FilterEnum } from 'Common/FieldEnum';
import { SecurityPreferences } from 'Common/Security/SecurityPreferences';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import { DatePickerCustomButton } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';

import { PhysicalItemsInfo as PhysicalItemsInfoContainer } from '../../containers/createEditPhysical/PhysicalItemsInfo';

const CreateEditPhysicalComponent = props => {
  const {
    isDisabled,
    onChangeOfSiteAndDate,
    handleChange,
    filterValues,
    clearFilters,
    assignItemsBidGroupData,
    assignItemsItemGroupData,
    assignItemsStorageLocationData,
    fetchPhysicalItems,
    physicalItemsData,
    onLoadOnHandClick,
    selectedSite,
    isLoadOnHandClicked,
    IsNewEdit,
    accordionActiveIndex,
    handleChangeAccordion,
    minDate,
    maxDate,
    onResetPageOnDataChange,
    resetPageOnDataChange,
    fetchSiteWarningDataLoading,
  } = props;

  const fields = [
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: assignItemsItemGroupData,
      label: 'ITEM GROUP',
      disabled: isDisabled,
    },
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: assignItemsBidGroupData,
      label: 'BID GROUP',
      maxLength: 20,
      disabled: isDisabled,
    },
    {
      name: FilterEnum.GroupId_Location,
      component: SelectField,
      type: 'text',
      options: assignItemsStorageLocationData,
      label: 'Storage Location',
      maxLength: 20,
      disabled: isDisabled,
    },
  ];
  return (
    <Form>
      <Grid>
        <Grid.Row columns={4}>
          <Grid.Column>
            <Field
              component={DatePickerField}
              label={'Physical Date'}
              dateFormat={DATE_FORMAT_FOR_UI}
              name={CreateEditPhysicalEnum.PhysicalDT}
              type={'text'}
              dropdownMode="select"
              includeDates={getDates(false)}
              minDate={minDate}
              maxDate={maxDate}
              onChange={onChangeOfSiteAndDate}
              customInput={<DatePickerCustomButton isDisabled={isDisabled} />}
            />
          </Grid.Column>
          <Grid.Column>
            <SiteComponent
              name={CreateEditPhysicalEnum.Site}
              isForm={true}
              label={'Site'}
              isAllRequired={false}
              showAllActiveSites={true}
              onChange={(newVal, preVal, field) =>
                onChangeOfSiteAndDate(null, newVal, preVal, field)
              }
              disabled={IsNewEdit !== NewEditPhysicalEnum.NEW}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name={CreateEditPhysicalEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
              disabled={isDisabled}
            />
          </Grid.Column>
        </Grid.Row>
        <Accordion fluid styled>
          <Accordion.Title
            active={!accordionActiveIndex}
            index={0}
            onClick={handleChangeAccordion}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!accordionActiveIndex}>
            <Grid className={'remove-spacing'}>
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
                disabled={isDisabled}
              />
              <Grid.Row
                style={{
                  marginTop: 16,
                }}
              >
                <Grid.Column>
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                    disabled={isDisabled}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Grid.Row
          column={1}
          style={{
            marginTop: 16,
          }}
        >
          <Grid.Column width={4} floated={'right'} textAlign={'right'}>
            <SecurityPreferences scope={PreferencesEnum.PhysicalLoadOnHand}>
              {disabled => {
                return (
                  <Button
                    content="Load On Hand"
                    type={'button'}
                    onClick={onLoadOnHandClick}
                    disabled={
                      disabled
                        ? disabled
                        : isDisabled ||
                          (isLoadOnHandClicked ||
                            selectedSite === SiteStatusEnum.EMPTY)
                    }
                  />
                );
              }}
            </SecurityPreferences>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={PhysicalItemsInfoContainer}
              name={CreateEditPhysicalEnum.PhysicalItemsInfo}
              {...{
                dataSource: physicalItemsData,
                fetchPhysicalItems,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
                fetchSiteWarningDataLoading,
              }}
              disabled={isDisabled}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};
CreateEditPhysicalComponent.propTypes = {
  isDisabled: PropTypes.bool,
  onChangeOfSiteAndDate: PropTypes.func,
  handleChange: PropTypes.func,
  filterValues: PropTypes.object,
  clearFilters: PropTypes.func,
  assignItemsBidGroupData: PropTypes.array.isRequired,
  assignItemsItemGroupData: PropTypes.array.isRequired,
  assignItemsStorageLocationData: PropTypes.array.isRequired,
  physicalItemsData: PropTypes.array.isRequired,
  fetchPhysicalItems: PropTypes.bool,
  onLoadOnHandClick: PropTypes.func,
  selectedSite: PropTypes.string,
  isLoadOnHandClicked: PropTypes.bool,
  IsNewEdit: PropTypes.string,
  accordionActiveIndex: PropTypes.number,
  handleChangeAccordion: PropTypes.func,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onResetPageOnDataChange: PropTypes.func,
  resetPageOnDataChange: PropTypes.bool,
  fetchSiteWarningDataLoading: PropTypes.bool,
};
CreateEditPhysicalComponent.defaultProps = {
  isDisabled: false,
  onChangeOfSiteAndDate: () => {},
  handleChange: () => {},
  clearFilters: () => {},
  onLoadOnHandClick: () => {},
  handleChangeAccordion: () => {},
  onResetPageOnDataChange: () => {},
  fetchPhysicalItems: false,
  resetPageOnDataChange: true,
  selectedSite: '',
  isLoadOnHandClicked: false,
  IsNewEdit: '0',
  accordionActiveIndex: 0,
  filterValues: {},
  minDate: null,
  maxDate: null,
  fetchSiteWarningDataLoading: false,
};
export default CreateEditPhysicalComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/components/createEditPhysical/CreateEditPhysical.js